export const GET_TESTIMONIALS = "GET_TESTIMONIALS";
export const GET_TESTIMONIALS_LOADING = "GET_TESTIMONIALS_LOADING";
